<p-table [value]="payments" [paginator]="true" [rows]="5" [showCurrentPageReport]="true" 
currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">
    <ng-template pTemplate="header">
        <tr>
            <th>Date</th>
            <th>Amount</th>
            <!-- <th>Received Amount</th> -->
            <th>Description</th>
            <th>Status</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-payment>
        <tr>
            <td>{{payment.created * 1000 | date : 'short'}}</td>
            <td>{{payment.amount / 100 | currency}}</td>
            <!-- <td>{{payment.amount_received / 100 | currency}}</td> -->
            <td>{{payment.description}}</td>
            <td>{{payment.status}}</td>
        </tr>
    </ng-template>
</p-table>